import { useEnvironmentVariables } from "@workleap-ai/shared";
import { registerHoneycombInstrumentation } from "@workleap/honeycomb";
import { useEffect } from "react";

export const OpenTelemetryInitializer = () => {
    const { openTelemetryProxyUrl } = useEnvironmentVariables();

    useEffect(() => {
        if (!openTelemetryProxyUrl) {
            return;
        }

        registerHoneycombInstrumentation("ai-app-frontend", [/.*.workleap(-stg|-dev)?.com\/[^.]*/], {
            proxy: openTelemetryProxyUrl,
            fetchInstrumentation: conf => conf,
            xmlHttpRequestInstrumentation: conf => conf,
            documentLoadInstrumentation: false
        });
    }, [openTelemetryProxyUrl]);

    return null;
};
